var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.82568 16.9769C14.0369 16.9769 17.4507 13.563 17.4507 9.35187C17.4507 5.1407 14.0369 1.72687 9.82568 1.72687C5.61451 1.72687 2.20068 5.1407 2.20068 9.35187C2.20068 13.563 5.61451 16.9769 9.82568 16.9769Z",
    fill: "#8F95AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70068 5.35187V9.97687",
    stroke: "#8F95AC",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8257 11.8519L9.57568 9.47687",
    stroke: "#8F95AC",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82557 0.851874C4.57557 -0.273126 2.57557 -0.273126 1.32557 0.976874C0.0755682 2.22687 0.0755682 4.22687 1.20057 5.47687L5.82557 0.851874Z",
    fill: "#8F95AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7007 0.851874C14.9507 -0.273126 16.9507 -0.273126 18.2007 0.976874C19.4507 2.22687 19.4507 4.22687 18.3257 5.47687L13.7007 0.851874Z",
    fill: "#8F95AC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.69ca8b33.svg";
export { ForwardRef as ReactComponent };